import { Separator as SeparatorPrimitive } from '@base-ui/react/separator';
import { cn } from '../utils/cn';

type SeparatorVariant = 'solid' | 'dashed' | 'dotted' | 'double';
type SeparatorSize = 'sm' | 'md' | 'lg';

type SeparatorProps = SeparatorPrimitive.Props & {
  variant?: SeparatorVariant;
  size?: SeparatorSize;
};

const separatorVariantClasses: Record<SeparatorVariant, Record<SeparatorSize, string>> = {
  solid: {
    sm: 'bg-border data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch',
    md: 'bg-border data-horizontal:h-0.5 data-horizontal:w-full data-vertical:w-0.5 data-vertical:self-stretch',
    lg: 'bg-border data-horizontal:h-1 data-horizontal:w-full data-vertical:w-1 data-vertical:self-stretch',
  },
  dashed: {
    sm: 'bg-transparent border-border data-horizontal:h-0 data-horizontal:w-full data-horizontal:border-t data-horizontal:border-dashed data-vertical:w-0 data-vertical:self-stretch data-vertical:border-l data-vertical:border-dashed',
    md: 'bg-transparent border-border data-horizontal:h-0 data-horizontal:w-full data-horizontal:border-t-2 data-horizontal:border-dashed data-vertical:w-0 data-vertical:self-stretch data-vertical:border-l-2 data-vertical:border-dashed',
    lg: 'bg-transparent border-border data-horizontal:h-0 data-horizontal:w-full data-horizontal:border-t-4 data-horizontal:border-dashed data-vertical:w-0 data-vertical:self-stretch data-vertical:border-l-4 data-vertical:border-dashed',
  },
  dotted: {
    sm: 'bg-transparent border-border data-horizontal:h-0 data-horizontal:w-full data-horizontal:border-t data-horizontal:border-dotted data-vertical:w-0 data-vertical:self-stretch data-vertical:border-l data-vertical:border-dotted',
    md: 'bg-transparent border-border data-horizontal:h-0 data-horizontal:w-full data-horizontal:border-t-2 data-horizontal:border-dotted data-vertical:w-0 data-vertical:self-stretch data-vertical:border-l-2 data-vertical:border-dotted',
    lg: 'bg-transparent border-border data-horizontal:h-0 data-horizontal:w-full data-horizontal:border-t-4 data-horizontal:border-dotted data-vertical:w-0 data-vertical:self-stretch data-vertical:border-l-4 data-vertical:border-dotted',
  },
  double: {
    sm: 'bg-transparent border-border data-horizontal:h-0 data-horizontal:w-full data-horizontal:border-t-2 data-horizontal:border-double data-vertical:w-0 data-vertical:self-stretch data-vertical:border-l-2 data-vertical:border-double',
    md: 'bg-transparent border-border data-horizontal:h-0 data-horizontal:w-full data-horizontal:border-t-4 data-horizontal:border-double data-vertical:w-0 data-vertical:self-stretch data-vertical:border-l-4 data-vertical:border-double',
    lg: 'bg-transparent border-border data-horizontal:h-0 data-horizontal:w-full data-horizontal:border-t-8 data-horizontal:border-double data-vertical:w-0 data-vertical:self-stretch data-vertical:border-l-8 data-vertical:border-double',
  },
};

function Separator({
  className,
  orientation = 'horizontal',
  variant = 'solid',
  size = 'sm',
  ...props
}: SeparatorProps) {
  return (
    <SeparatorPrimitive
      data-slot="separator"
      orientation={orientation}
      className={cn('shrink-0', separatorVariantClasses[variant][size], className)}
      {...props}
    />
  );
}

export { Separator };
